import React, { createContext, memo, useReducer, useMemo } from 'react';
import { defaultSettingsState, settingsReducer } from './settingsReducer';
var store = createContext({
    settings: defaultSettingsState,
    dispatchSettings: function () {
    }
});
var Provider = store.Provider;
export var useSettings = function () {
    var _a = React.useContext(store), settings = _a.settings, dispatchSettings = _a.dispatchSettings;
    var settingsIsFetching = useMemo(function () { return settings.isFetching; }, [settings.isFetching]);
    var ui = useMemo(function () { return settings.ui; }, [settings.ui]);
    return { settings: settings, ui: ui, settingsIsFetching: settingsIsFetching, dispatchSettings: dispatchSettings };
};
export var SettingsProvider = memo(function (_a) {
    var children = _a.children;
    var _b = useReducer(settingsReducer, defaultSettingsState), settings = _b[0], dispatchSettings = _b[1];
    return (React.createElement(Provider, { value: { settings: settings, dispatchSettings: dispatchSettings } }, children));
});
